import { LoggingServiceWeb } from './LoggingServiceWeb'

export default LoggingServiceWeb

export const defaultLoggingService = new LoggingServiceWeb()
